import type { ElementType, FC, Ref } from "react";

import type { ChildrenProp } from "../../props/ChildrenProp";
import type { ClassNameProp } from "../../props/ClassNameProp";
import { PolyMorphicElement } from "../PolyMorphicElement";
import { mergeClasses } from "@huub-web/utils";

import { gradientTextStyle } from "./GradientText.css";

export type GradientTextProps = ChildrenProp &
  ClassNameProp & {
    as?: ElementType;
    /**
     * Ref forwarded to the root element
     */
    ref?: Ref<HTMLSpanElement>;
  };

export const GradientText: FC<GradientTextProps> = ({
  as = "span",
  children,
  className,
  ref,
}) => (
  <PolyMorphicElement
    ref={ref}
    as={as}
    className={mergeClasses(gradientTextStyle, className)}
  >
    {children}
  </PolyMorphicElement>
);
